define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/xml",
	"./_ValuesFrom",
	"./Values"
], function(declare, csi, _, xml, _ValuesFrom, Values) {

	return declare(_ValuesFrom, {
		_onDataCreateValuesStore: function(/*Object[]*/data, /*Object*/storeOptions) {
			// summary: create Values store from data
			// convert pairs data into values for single spec
			var otherFilterValue = this._filterValue;
			var pairsStore = this._store;
			var bFirst = (this.spec == pairsStore.spec1);
			var pt = bFirst ? "Type" : "Type2";
			var pv = bFirst ? "Value" : "Value2";
			var obj = {};

			if (otherFilterValue == null) {
				// extract Values store for one spec based on value-pair data
				csi.hashArray(data, pv, null, obj, true);
			} else {
				// extract Values store for one spec given a specific filter value of the other spec
				var otherSpec = bFirst ? pairsStore.spec2 : pairsStore.spec1;
				var otherValue = bFirst ? "Value2" : "Value";

				_.each(data, function(item) {
					if (xml.valuePassesFilter(otherSpec.querySpec.type, item[otherValue], otherFilterValue)) {
						obj[item[pv]] = [item];
					}
				});
			}

			var v = _.map(obj, function(items, value) {
				const firstItem = items[0];
				const count = items.reduce((memo, item) => memo + item.Count, 0);
				const refs = firstItem.Refs ? items.reduce((memo, item) => memo.concat(item.Refs), []) : null;

				console.assert(!refs || (count === refs.length));

				return {
					Count: count,
					Refs: refs,
					Type: firstItem[pt],
					Value: firstItem[pv]
				};
			});

			return Values.createFromServerValues(v, storeOptions);
		}
	});
});